import { useDebouncedValue } from "../../../../hooks/useDebouncedValue";
import { publicPageAddress } from "../../pageAddress";
import type { PageSection } from "../../pageSection";
import styles from "./PageAddressFields.module.css";

type PageAddressPreviewProps = {
  id: string;
  section: PageSection;
  sectionHome?: boolean;
  parentSlug: string | null;
  segment: string;
};

const ANNOUNCE_AFTER_PAUSE_MS = 500;

export function PageAddressPreview({
  id,
  section,
  sectionHome = false,
  parentSlug,
  segment,
}: PageAddressPreviewProps) {
  const address = sectionHome
    ? publicPageAddress(section, null, "")
    : publicPageAddress(section, parentSlug, segment.trim() || "…");
  const announcedAddress = useDebouncedValue(address, ANNOUNCE_AFTER_PAUSE_MS);

  return (
    <>
      <p id={id} className={styles.preview}>
        Public address: <span className={styles.address}>{address}</span>
      </p>
      <span className="sr-only" aria-live="polite">
        Public address: {announcedAddress}
      </span>
    </>
  );
}
